<div class="blue-container">
  <div class="blue-container__card">
    <div style="max-width: 1147px; margin: 0 auto">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
